import { Injectable } from '@angular/core';
import { calculationConverter } from '@seu-converter';
import { RequestService, StoreService, ToastService } from '@seu-services';
import {
  SEU_API_ENDPOINTS,
  SeuActiveCalculation,
  SeuCalculationPayload,
  SeuCalculationResponseApi,
} from '@seu-types';
import { first } from 'lodash-es';
import { catchError, firstValueFrom, of } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class CalculationService {
  constructor(
    private requestService: RequestService,
    private store: StoreService,
    private toastService: ToastService
  ) {}

  public async doCalculation(
    offerId: string,
    activeCalculation: SeuActiveCalculation
  ): Promise<boolean> {
    const endpoint = SEU_API_ENDPOINTS.calculation.replace(':offerId', offerId);

    const data: SeuCalculationPayload = {
      computationInputs: [
        {
          globalParameterSetId: activeCalculation.globalParameterSetId,
          interconnectionId: activeCalculation.interconnectionId,
          operatingConditionId: activeCalculation.operatingConditionId,
        },
      ],
    };

    const responseData = await firstValueFrom(
      this.requestService
        .post<SeuCalculationResponseApi>(endpoint as SEU_API_ENDPOINTS, data)
        .pipe(
          catchError(() => {
            this.toastService.addToast({
              type: 'error',
              text: 'calculation.toasts.calculation-error',
            });

            return of(null);
          })
        )
    );

    if (responseData) {
      const calculationResponseItems =
        calculationConverter.fromApi(responseData);

      const calculationResponseItem = first(calculationResponseItems);

      if (!calculationResponseItem) {
        console.error('Calculation response is not valid');
        return false;
      }

      this.store.addCalculationResponseItem({
        ...calculationResponseItem,
        uid: activeCalculation.uid,
      });
      return true;
    }

    return false;
  }
}
